import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminFetchData } from "../../../../../store/slice/Admin";
import { FaSyncAlt } from "react-icons/fa";
import { Table } from "./Table";
import { Table2 } from "./Table2";
import {
  addOrganizerFilters,
  clearAllFilters,
  loadFilterOrganizer,
  sorted,
  sorting,
} from "../../../../../store/slice/OrganizerFilters";
import SelectBox from "../../../../global/SelectBox";

const PayoutMethods = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);
  const { paypal, stripe, loading } = useSelector((state) => state.admin);
  const {
    filters: { keyword },
    sorting_value,
    filter_data,
  } = useSelector((state) => state.organizerFilters);

  useEffect(() => {
    dispatch(
      adminFetchData({
        endPoint: "admin/paypal",
        state: "paypal",
        token: user.token,
      })
    );
    dispatch(
      adminFetchData({
        endPoint: "admin/stripe",
        state: "stripe",
        token: user.token,
      })
    );
  }, []);

  useEffect(() => {
    dispatch(loadFilterOrganizer({ data: paypal, key: "paypal" }));
    dispatch(loadFilterOrganizer({ data: stripe, key: "stripe" }));
  }, [dispatch, paypal, stripe]);

  useEffect(() => {
    dispatch(clearAllFilters());
  }, []);

  useEffect(() => {
    dispatch(sorted("paypal"));
    dispatch(sorted("stripe"));
  }, [sorting_value]);

  const add_filter = (e) => {
    const { name, value } = e.target;
    dispatch(addOrganizerFilters({ name, value }));
  };

  // Search Filter
  const add_filter3 = (name, value) => {
    dispatch(sorting({ name, value }));
  };
  // Sorting select Box options
  const options = [
    { id: "date-desc", name: "Creation date (desc)" },
    { id: "date-asc", name: "Creation date (asc)" },
  ];

  return (
    <>
      <div className="box shadow-none bg-gray mb-4 organizer-event MyScanners">
        <div className="row">
          <div className="col-sm-12 col-lg-2 text-center text-lg-start mb-3 mb-lg-0 align-self-center">
            <span className="center-lg-y text-muted">
              {filter_data.paypal?.length + filter_data.stripe?.length}{" "}
              result(s) found
            </span>
          </div>
          <div className="col-sm-12 col-lg-4 d-flex align-items-center justify-content-center">
            <ul className="d-flex">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownMenuLink"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Search
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <li>
                    <div className="signform">
                      <label htmlFor="keyword" className="form-label dashboard">
                        Keyword
                      </label>
                      <input
                        type="text"
                        name="keyword"
                        className="form-control"
                        id="keyword"
                        value={keyword}
                        onChange={add_filter}
                      />
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="col-sm-12 col-lg-6 d-flex align-items-center justify-content-around">
            <form className="text-start d-flex align-items-center">
              <label htmlFor="sort" className="">
                Sort by{" "}
              </label>
              <SelectBox
                name="sorting_value"
                options={options}
                val={sorting_value}
                change={add_filter3}
              />
            </form>
            {/* <Tooltip title="Add a new Venue Type">
              <Link
                to="add"
                className="btn btn-dark ms-3"
                style={{ fontSize: "12px" }}
              >
                <FaPlus />
              </Link>
            </Tooltip> */}
          </div>
        </div>
      </div>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center">
          <FaSyncAlt className="spinIcon" />
        </div>
      ) : (
        <>
          <Table paypal={filter_data.paypal} />
        </>
      )}
      <br />
      <br />
      <hr />
      <br />
      <br />

      {loading ? (
        <div className="d-flex align-items-center justify-content-center">
          <FaSyncAlt className="spinIcon" />
        </div>
      ) : (
        <>
          <Table2 stripe={filter_data.stripe} />
        </>
      )}
    </>
  );
};

export default PayoutMethods;
